import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver errors globally
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args && args.length > 0 && typeof args[0] === 'string' && 
      (args[0].includes('ResizeObserver') || args[0].includes('loop limit exceeded'))) {
    return;
  }
  resizeObserverErr(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
